var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFooterLogoSign(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 39,
    viewBox: "0 0 57 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.2111 0C36.5407 0 29.4415 11.3943 28.5 11.8634C27.5603 11.3943 20.4593 0 12.7889 0C5.1185 0 0 3.74905 0 9.25534C0 27.8521 15.1363 33.5999 23.0535 38.6995C24.3322 39.524 26.3019 38.5052 25.5372 37.4142C21.8172 32.1008 14.3255 25.3522 14.3255 13.2001C14.3255 12.5436 14.3513 11.6788 15.1934 11.4554C16.0354 11.2319 17.1133 11.2319 18.0437 12.631C19.7517 15.2002 25.3217 23.1564 28.465 23.2744V23.2772C28.476 23.2772 28.4889 23.2772 28.5 23.2772C28.5111 23.2772 28.524 23.2772 28.535 23.2772V23.2744C31.6783 23.1564 37.2501 15.2016 38.9563 12.631C39.8849 11.2319 40.9646 11.2319 41.8066 11.4554C42.6487 11.6788 42.6745 12.5436 42.6745 13.2001C42.6745 25.3522 35.1828 32.1008 31.4628 37.4142C30.6981 38.5052 32.6678 39.5226 33.9465 38.6995C41.8638 33.5999 57 27.8521 57 9.25534C57 3.74905 52.0436 0 44.2111 0Z",
    fill: "#424242"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterLogoSign);
export default __webpack_public_path__ + "static/media/footer-logo-sign.e97fde6f42ec16e8c08e6d5f6d244bef.svg";
export { ForwardRef as ReactComponent };